export interface ExposedPromise<T> {
    promise: Promise<T>;
    resolve: (t: T) => void;
    reject: (error: any) => void;
}

export default function createExposedPromise<T>(): ExposedPromise<T> {
    let resolve: (t: T) => void | undefined;
    let reject: (error: any) => void;

    const promise = new Promise<T>((_resolve, _reject) => {
        resolve = _resolve;
        reject = _reject;
    });

    return {promise, resolve: resolve!, reject: reject!};
}
